import {ExternalLog} from "../../externalLogging/ExternalLog";
import {TrackingVerificationErrorLOFactory} from "../../externalLogging/factories/TrackingVerificationErrorLOFactory";
import {Timer} from "@goodgamestudios/createjs-utilities";
import {getLogger} from "@goodgamestudios/logger";
import TimerEvent = createjs.TimerEvent;
const logger = getLogger("Tracking.TrackingVerifier");
/**
 * TrackingVerifier controls the execution of the tracking events. With his functionality we can be sure, that
 * execution is not overwritten somewhere. Tracking patterns, which are used for comparing of the results, are
 * specific to classic/mobile clients.
 *
 * If you want to use a Verifier in your project, just set "isActive" at the start of verification process and
 * use the method "startVerification" at the end.
 *
 * If all events are fired, you will see the debug-message on your debugger-window. In other case, verifier will
 * create a new log-object and send the information about missed events to the "Splunk".
 */
export class TrackingVerifier {
    private TRACKING_LIST_SEPARATOR: string = ";";
    private TRACKING_TIMER_REPEAT_COUNT: number = 1;

    private _listOfFiredEvents: any[] = [];
    private _currentTrackingPattern: any[];
    private _currentCase: string;
    private _isActive: boolean = false;

    private _verificationTimer: Timer;

    public keepEvent(eventId: number): void {
        if (!this.isActive) {
            return;
        }
        //  TODO HTML5 we might need to do same for ClientFunnel
        // // We compare the game states of the first instance tracking events and eventIds of all other tracking events.
        // if (eventId == TrackingEventIds.FIRST_INSTANCE) {
        //     let gameState: string = ((<FirstInstanceTrackingEvent>TrackingCache.getInstance().getEvent(eventId))).gameState;
        //     this._listOfFiredEvents.push(gameState);
        // }
        // else {
        this._listOfFiredEvents.push(eventId.toString());
        // }
    }

    /**
     * Verifier starts to compare list of fired events with the specific pattern.
     *
     * @param currentTrackingCase - information about tracking case for the external Logger.
     * @param pattern - current pattern of the tracking events.
     * @param timerTimeout - not needed, if you don't use the timer.
     */
    public startVerification(currentTrackingCase: string, pattern: any[], timerTimeout: number = 0): void {
        if (!this.isActive) {
            return;
        }

        this._currentCase = currentTrackingCase;
        this._currentTrackingPattern = pattern;

        if (timerTimeout > 0) {
            this._verificationTimer = new Timer(timerTimeout, this.TRACKING_TIMER_REPEAT_COUNT);
            this._verificationTimer.addEventListener(TimerEvent.TIMER_COMPLETE, this.onVerificationTimerComplete);
            this._verificationTimer.start();
        }
        else {
            this.verifyTracking();
        }
    }


    private onVerificationTimerComplete = (timerEvent: TimerEvent) => this.verifyTracking();

    private verifyTracking(): void {
        let missedEvents: any[] = [];

        // compare the events from pattern and "listOfFiredEvents".
        // If some event is missing, push him to the "missingEvents" array.
        while (this._currentTrackingPattern.length != 0) {
            let eventRepresentation: string = this._currentTrackingPattern.pop();

            if (this.eventWasNotFired(eventRepresentation)) {
                missedEvents.push(eventRepresentation);
            }
        }

        if (missedEvents.length == 0) {
            ("Tracking verification completed! All events were fired.");
        }
        else {
            logger.error("Tracking verification error! Some tracking events were not fired: " + missedEvents.join(this.TRACKING_LIST_SEPARATOR) + ", please contact Core-team immediately.");
            ExternalLog.logger.log(new TrackingVerificationErrorLOFactory(TrackingVerificationErrorLOFactory.TRACKING_EVENTS_MISSING_ERROR, this._currentCase, missedEvents.join(this.TRACKING_LIST_SEPARATOR)));
        }

        this.dispose();
    }

    private eventWasNotFired(eventRepresentation: string): boolean {
        return this._listOfFiredEvents.indexOf(eventRepresentation) == -1;
    }

    public get isActive(): boolean {
        return this._isActive;
    }

    public set isActive(value: boolean) {
        this._isActive = value;
        logger.debug("Tracking verification is active: " + this._isActive);
    }

    public get listOfFiredEvents(): any[] {
        return this._listOfFiredEvents.concat();
    }

    public set listOfFiredEvents(value: any[]) {
        if (value && value.length) {
            let length: number = value.length;
            let i: number;

            for (i = 0; i < length; i++) {
                if (this._listOfFiredEvents.indexOf(value[i]) < 0) {
                    this._listOfFiredEvents.push(value[i]);
                }
            }
        }
    }

    public dispose(): void {
        if (this.isActive) {
            this.isActive = false;

            if (this._verificationTimer) {
                this._verificationTimer.stop();
                this._verificationTimer.removeEventListener(TimerEvent.TIMER_COMPLETE, this.onVerificationTimerComplete);
                this._verificationTimer = null;
            }

            this._listOfFiredEvents = null;
            this._currentCase = null;
            this._currentTrackingPattern = null;
        }
    }
}
